import React, { useEffect, useState } from 'react';
import { apiUrl } from '../../../constants/apiConsts';
import ImageApi from '../../../api/image';
import { Link,  } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


const Home = ({ item, showWorshipLocations }) => {
  const [image, setImage] = useState(null);

  useEffect(() => {
    if (item.image_id) {
      ImageApi.getImage(`${apiUrl}/content/image/${item.image_id}/thumbnail`).then((imageUrl) => {
        setImage(imageUrl);
      });
    }
  }, []);


  const createHomeHubItem = (item) => {

  const getLink = (type) => {
    if (type === "communityHub") {
      return "/communities"
    } else if (type === "worshipLocations") {
      return "/worship-locations"
    } else if (type === "askAunty") {
      return "/ask-aunty-or-uncle"
    } else if (type === "eventListing") {
      return "/events"
    } else if (type.includes('KBLink_')) {
      const categorySlug = type.replace('KBLink_', '')
      return `/knowledgebase?category=${encodeURIComponent(categorySlug)}`
    }
  }


    switch (item.type){
      case "functionality":
        if (!showWorshipLocations && item.functionality === 'worshipLocations') return null

        return (
          <Link
            className="home-item-container text-decoration-none"
            to={getLink(item.functionality)}
          >
            {image && <img width="28" height="28" src={image} alt="icon" />}
            <div className="d-flex flex-column justify-content-center pl-3">
              <h6 className="m-0 home-item-title">{item.title}</h6>
              <p className="m-0 home-item-description">{item.subtitle}</p>
            </div>
            <FontAwesomeIcon
              icon={['fas', 'chevron-right']}
              className="home-back-link-icon"
            />
          </Link>
        )
      case "url":
        return (
          <a
            target={'_blank'} rel="noreferrer"
            className="home-item-container text-decoration-none"
            href={item.url}
          >
            {image && <img width="28" height="28" src={image} alt="icon" />}
            <div className="d-flex flex-column justify-content-center pl-3">
              <h6 className="m-0 home-item-title">{item.title}</h6>
              <p className="m-0 home-item-description">{item.subtitle}</p>
            </div>
            <FontAwesomeIcon
              icon={['fas', 'chevron-right']}
              className="home-back-link-icon"
            />
          </a>
        )
      case "content":
        return (
          <Link
            className="home-item-container text-decoration-none"
            to={`/content?id=${item.id}`}
          >
            {image && <img width="28" height="28" src={image} alt="icon" />}
            <div className="d-flex flex-column justify-content-center pl-3">
              <h6 className="m-0 home-item-title">{item.title}</h6>
              <p className="m-0 home-item-description">{item.subtitle}</p>
            </div>
            <FontAwesomeIcon
              icon={['fas', 'chevron-right']}
              className="home-back-link-icon"
            />
          </Link>
        )
      }
    }

  return (
    <div>
      {createHomeHubItem(item)}
    </div>
  );
};

export default Home;
